import Popper from 'popper.js';
import { keyCodes } from './../../utils';

const defaultConfig = {
  rootContainerSelector: '#root-tooltips',
  popperOptions: {
    placement: 'top',
    removeOnDestroy: true,
    modifiers: {
      arrow: {
        element: '.tooltip__arrow',
      },
    },
  },
};

export default class Tooltip {
  constructor(element, config) {
    this.element = element;
    this.config = { ...defaultConfig, ...config };

    this.handleVisibility = this.handleVisibility.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.init();

    return this;
  }

  init() {
    this.trigger = document.querySelector(
      `[aria-describedby=${this.element.getAttribute('id')}]`
    );

    if (!this.trigger) {
      // eslint-disable-next-line no-console
      console.warning(
        `\`tooltip trigger\` element is not defined and the tooltip cannot be attached. Please provide an element with [aria-describedby=${this.element.getAttribute(
          'id'
        )}]`
      );
    }

    this.rootContainer = document.querySelector(
      this.config.rootContainerSelector
    );

    if (this.rootContainer) {
      this.rootContainer.appendChild(this.element);
    } else {
      // eslint-disable-next-line no-console
      console.warning(
        `\`rootContainer\` element is not defined. Tooltips will be placed inside content which can affect positioning. Please provide \`rootContainer\` element (should be placed outside of main contant, usualy in end of <body /> tag)`
      );
    }

    this.instance = new Popper(
      this.trigger,
      this.element,
      this.config.popperOptions
    );

    this.trigger.addEventListener('mouseenter', this.handleVisibility);
    this.trigger.addEventListener('mouseleave', this.handleVisibility);
    this.trigger.addEventListener('focus', this.handleVisibility);
    this.trigger.addEventListener('blur', this.handleVisibility);
  }

  handleVisibility(e) {
    if (e.type === 'mouseenter' || e.type === 'focus') {
      this.show();
    }

    if (e.type === 'blur') {
      this.hide();
    }

    if (e.type === 'mouseleave') {
      const shouldClose = this.shouldClose(e);

      if (shouldClose) {
        this.hide();
      }
    }
  }

  shouldClose(e) {
    const mouseLeftTo = e.relatedreference || e.toElement || e.relatedTarget;

    const callback = e2 => {
      const mouseLeftTo2 =
        e2.relatedreference || e2.toElement || e2.relatedTarget;

      this.element.removeEventListener('mouseleave', callback);

      if (!this.trigger.contains(mouseLeftTo2)) {
        this.hide();
      }
    };

    if (this.element.contains(mouseLeftTo)) {
      this.element.addEventListener('mouseleave', callback);
      return false;
    }

    return true;
  }

  onKeydown(e) {
    if (e.which === keyCodes.ESC) {
      this.hide();
    }
  }

  show() {
    this.element.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', this.onKeydown);
  }

  hide() {
    this.element.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', this.onKeydown);
  }

  update() {
    this.instance.update();
  }

  destroy() {
    this.trigger.removeEventListener('mouseenter', this.handleVisibility);
    this.trigger.removeEventListener('mouseleave', this.handleVisibility);
    this.trigger.removeEventListener('focus', this.handleVisibility);
    this.trigger.removeEventListener('blur', this.handleVisibility);

    this.instance.destroy();
  }
}



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.static.js